import { initAcrawler } from '../../utils/acrawler';
import BaseInterface from '../base/index';
import { TypeCommon } from '../../types/auth';

import { TypeInitProps } from '../../types/index';
import Common from './common';

export default class AppInterface extends BaseInterface {
  public common: TypeCommon;

  constructor(props: TypeInitProps) {
    super(props, 'auth');
    const { printLog = false, acrawler = '' } = props;
    // log
    if (printLog) {
      console.log('AuthInterface Initial Props >>>>', props);
    }
    // acrawler
    if (acrawler) {
      initAcrawler(acrawler, props);
    }

    // web interfaces
    let argus = { ...props, request: this.request };

    this.common = new Common(argus);
  }
}
